/**
 * see-it-in-your-size.js — <siiys-switcher>.
 *
 * Inside the SIIYS modal:
 *  1. Size swap — clicking a size button ([data-size-btn]) shows that size's panels
 *     ([data-size-panel] — the model image + the model-details pills) and hides the rest. All panels
 *     are already cloned into the DOM, so the swap is an instant visibility toggle — no fetch, no shift.
 *  2. Wipe-through underline on hover — mirrors <region-widget>'s trigger: enter from the left on
 *     mouseenter (is-line-in), continue out to the right on mouseleave (is-line-out), then drop the
 *     class on transitionend so the bar snaps back off-left, ready to loop.
 */
(function () {
  if (customElements.get('siiys-switcher')) return;

  class SiiysSwitcher extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);

      // Per-button hover wipe (mouseenter/leave don't bubble, so bind per button).
      this._lineBtns = [];
      var btns = this.querySelectorAll('[data-size-btn]');
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        var rec = {
          btn: btn,
          line: btn.querySelector('.siiy__size-line'),
          enter: this.lineIn.bind(this, btn),
          leave: this.wipeOut.bind(this, btn),
          end: this.onLineEnd.bind(this, btn),
        };
        btn.addEventListener('mouseenter', rec.enter);
        btn.addEventListener('mouseleave', rec.leave);
        if (rec.line) rec.line.addEventListener('transitionend', rec.end);
        this._lineBtns.push(rec);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      (this._lineBtns || []).forEach(function (r) {
        r.btn.removeEventListener('mouseenter', r.enter);
        r.btn.removeEventListener('mouseleave', r.leave);
        if (r.line) r.line.removeEventListener('transitionend', r.end);
      });
      this._lineBtns = [];
    }

    onClick(e) {
      var btn = e.target.closest('[data-size-btn]');
      if (!btn || !this.contains(btn)) return;

      var size = btn.getAttribute('data-size-btn');

      this.querySelectorAll('[data-size-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-size-panel') !== size;
      });

      this.querySelectorAll('[data-size-btn]').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
    }

    /* ---------------- Wipe-through underline ---------------- */
    lineIn(btn) {
      btn.classList.remove('is-line-out');
      btn.classList.add('is-line-in');
    }

    // Exit to the right — only from the "in" state; from parked (off-left) it would sweep across.
    wipeOut(btn) {
      if (!btn.classList.contains('is-line-in')) return;
      btn.classList.remove('is-line-in');
      btn.classList.add('is-line-out');
    }

    // After the exit finishes, drop the class → the bar snaps back off-left (rest has no transition).
    onLineEnd(btn, e) {
      if (e.propertyName !== 'transform') return;
      if (btn.classList.contains('is-line-out')) btn.classList.remove('is-line-out');
    }
  }

  customElements.define('siiys-switcher', SiiysSwitcher);
})();
